import { Injectable } from "@angular/core";
import { OrganisationMemberConnector } from "./organisation-member.connector";
import { AppServerOrganisationMemberConnector } from "../../app-server-connectors";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { APIResponse, OrganisationMemberDocument } from "server-model";

@Injectable()
export class OrganisationMemberDataService {
    private organisationMemberConnector: OrganisationMemberConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.organisationMemberConnector = new AppServerOrganisationMemberConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getOrganisationMember(organisationId: string, organisationMemberId: string): Promise<APIResponse> {
        const response = await this.organisationMemberConnector.getOrganisationMember(organisationId, organisationMemberId);
        return response;
    }
    async createOrganisationMember(organisationMemberDocument: OrganisationMemberDocument): Promise<APIResponse> {
        const response = await this.organisationMemberConnector.createOrganisationMember(organisationMemberDocument);
        return response;
    }
    async updateOrganisationMember(organisationId: string, organisationMemberId: string, organisationMemberDocument: OrganisationMemberDocument): Promise<APIResponse> {
        const response = await this.organisationMemberConnector.updateOrganisationMember(organisationId, organisationMemberId, organisationMemberDocument);
        return response;
    }
    async deleteOrganisationMember(organisationId: string, organisationMemberId: string): Promise<APIResponse> {
        const response = await this.organisationMemberConnector.deleteOrganisationMember(organisationId, organisationMemberId);
        return response;
    }
}
